// Checkout / cart / order flow strings for CheckoutPage.
const dict = {
  uk: {
    currency: 'грн',
    promoLabel50: '-50 грн',
    errPromoNotFound: 'Промокод не знайдено',
    errorTitle: 'Помилка',
    warnMissingRequired: "Будь ласка, заповніть обов'язкові поля",
    balanceLoading: 'Зачекайте, завантаження даних акаунту...',
    balanceLoginRequired: 'Будь ласка, увійдіть в акаунт для оплати з балансу',
    insufficientBalance: 'Недостатньо коштів на балансі. Ваш баланс: {{balance}} грн, потрібно: {{amount}} грн',
    deductPrefix: 'Покупка',
    errDeductFailed: 'Помилка при списанні коштів з балансу',
    warnNoInStock: 'Немає товарів в наявності для замовлення',
    parentRequestSent: 'Запит надіслано батьку. Очікуй підтвердження.',
    errOrderCreate: 'Помилка при створенні замовлення. Спробуйте ще раз.',
    orderPlacedTitle: 'Замовлення оформлено!',
    orderPlacedThanks: 'Дякуємо за ваше замовлення. Ми зв\'яжемося з вами найближчим часом для підтвердження.',
    orderTotal: 'Сума: {{amount}} грн',
    backToShop: 'Повернутися до магазину',
    cartEmptyTitle: 'Кошик порожній',
    cartEmptyDesc: 'Додайте товари з каталогу, щоб оформити замовлення',
    goToShop: 'Перейти до магазину',
    backToShopLink: 'Назад до магазину',
    checkoutTitle: 'Оформлення замовлення',
    contactDetails: 'Контактні дані',
    firstNameLabel: "Ім'я *",
    firstNamePlaceholder: "Ваше ім'я",
    lastNameLabel: 'Прізвище *',
    lastNamePlaceholder: 'Ваше прізвище',
    phoneLabel: 'Телефон *',
    deliveryTitle: 'Доставка',
    deliveryOptions: {
      novaPoshta: 'Нова Пошта',
      ukrPoshta: 'Укрпошта',
      pickup: 'Самовивіз',
    },
    cityLabel: 'Місто *',
    cityPlaceholder: 'Назва міста',
    branchLabel: 'Відділення / Адреса',
    branchPlaceholder: 'Номер відділення або адреса',
    paymentTitle: 'Оплата',
    paymentOptions: {
      balance: 'Оплата з балансу',
      cod: 'Накладений платіж',
    },
    yourBalance: 'Ваш баланс:',
    loginForBalance: 'Увійдіть в акаунт для оплати з балансу',
    commentTitle: 'Коментар до замовлення',
    commentPlaceholder: 'Додаткові побажання...',
    submitting: 'Обробка...',
    submitOrderWithAmount: 'Підтвердити замовлення — {{amount}} грн',
    noItemsInStock: 'Немає товарів в наявності',
    yourOrderCount: 'Ваше замовлення ({{count}})',
    outOfStockNotice: 'Товари, яких немає в наявності, не включені в замовлення',
    outOfStockLabel: 'Немає в наявності',
    itemPrice: '{{amount}} грн',
    remove: 'Видалити',
    promoLabel: 'Промокод',
    promoPlaceholder: 'Введіть промокод',
    applyPromo: 'Застосувати',
    itemsCount: 'Товари ({{count}})',
    subtotalAmount: '{{amount}} грн',
    discountLabel: 'Знижка ({{label}})',
    discountAmount: '-{{amount}} грн',
    deliveryLabel: 'Доставка',
    deliveryByCarrier: 'За тарифами перевізника',
    totalLabel: 'Разом:',
    totalAmount: '{{amount}} грн',
    submitOrder: 'Підтвердити замовлення',
  },
  en: {
    currency: 'UAH',
    promoLabel50: '-50 UAH',
    errPromoNotFound: 'Promo code not found',
    errorTitle: 'Error',
    warnMissingRequired: 'Please fill in the required fields',
    balanceLoading: 'Please wait, loading account data...',
    balanceLoginRequired: 'Please log in to pay from your balance',
    insufficientBalance: 'Not enough funds. Your balance: {{balance}} UAH, need: {{amount}} UAH',
    deductPrefix: 'Purchase',
    errDeductFailed: 'Error deducting from balance',
    warnNoInStock: 'No items in stock for the order',
    parentRequestSent: 'Request sent to parent. Waiting for confirmation.',
    errOrderCreate: 'Error creating order. Please try again.',
    orderPlacedTitle: 'Order placed!',
    orderPlacedThanks: 'Thank you for your order. We will contact you shortly to confirm.',
    orderTotal: 'Total: {{amount}} UAH',
    backToShop: 'Back to shop',
    cartEmptyTitle: 'Cart is empty',
    cartEmptyDesc: 'Add items from the catalog to place an order',
    goToShop: 'Go to shop',
    backToShopLink: 'Back to shop',
    checkoutTitle: 'Checkout',
    contactDetails: 'Contact details',
    firstNameLabel: 'First name *',
    firstNamePlaceholder: 'Your first name',
    lastNameLabel: 'Surname *',
    lastNamePlaceholder: 'Your surname',
    phoneLabel: 'Phone *',
    deliveryTitle: 'Delivery',
    deliveryOptions: {
      novaPoshta: 'Nova Poshta',
      ukrPoshta: 'Ukrposhta',
      pickup: 'Self pickup',
    },
    cityLabel: 'City *',
    cityPlaceholder: 'City name',
    branchLabel: 'Branch / Address',
    branchPlaceholder: 'Branch number or address',
    paymentTitle: 'Payment',
    paymentOptions: {
      balance: 'Pay from balance',
      cod: 'Cash on delivery',
    },
    yourBalance: 'Your balance:',
    loginForBalance: 'Log in to pay from balance',
    commentTitle: 'Order comment',
    commentPlaceholder: 'Additional notes...',
    submitting: 'Processing...',
    submitOrderWithAmount: 'Confirm order — {{amount}} UAH',
    noItemsInStock: 'No items in stock',
    yourOrderCount: 'Your order ({{count}})',
    outOfStockNotice: 'Out-of-stock items are not included in the order',
    outOfStockLabel: 'Out of stock',
    itemPrice: '{{amount}} UAH',
    remove: 'Remove',
    promoLabel: 'Promo code',
    promoPlaceholder: 'Enter promo code',
    applyPromo: 'Apply',
    itemsCount: 'Items ({{count}})',
    subtotalAmount: '{{amount}} UAH',
    discountLabel: 'Discount ({{label}})',
    discountAmount: '-{{amount}} UAH',
    deliveryLabel: 'Delivery',
    deliveryByCarrier: 'Carrier rates',
    totalLabel: 'Total:',
    totalAmount: '{{amount}} UAH',
    submitOrder: 'Confirm order',
  },
};

export default dict;
